import { render, staticRenderFns } from "./PaymentOrderIndex.vue?vue&type=template&id=08f969bc"
import script from "./PaymentOrderIndex.vue?vue&type=script&lang=js"
export * from "./PaymentOrderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports